import * as Action from "../action/run_monitor_work_condition.action";

const initState = {
    isLoading: false, // 是否显示加载中
    workInfo: {
        list: [],
        total: 0
    }
}
/**
 * 工况查询reducer
 */
const workConditionReducer = (state = initState, action) =>{
    switch (action.type) {
        case Action.RUN_MONITOR_WORK_CONDITION_TABLE_INFO: // 工况查询列表
            return {
                ...state,
                workInfo: action.workInfo
            }
        case Action.RUN_MONITOR_WORK_CONDITION_TABLE_LOADING: // 表格loadingk控制
            return {
                ...state,
                isLoading: action.isLoading
            }
        default:
            return state;
    }
}

export default workConditionReducer;
